<template>
  <div
    style="max-height: calc(100vh - 500px);"
    class="scroll-content p-sm-2 p-md-4 my-3"
  >
    <b-row>
      <b-col sm="12" md="6">
        <b-form-group
          label="Insurance company"
          :state="formErrors.insuranceCompany.length == 0 ? null : false"
          :invalid-feedback="formErrors.insuranceCompany.join(', ')"
        >
          <template v-slot:label>
            Insurance company
            <span class="text-danger">*</span>
          </template>
          <v-select
            :class="
              insuranceCompanies.length == 0
                ? 'insurance-company-picker-hide-options'
                : ''
            "
            placeholder="Search for insurance companies"
            v-model="form.company"
            :options="insuranceCompanies"
            ><template #no-options="{ search }">
              {{
                search && search.length > 3 ? "Sorry, no matching options" : ""
              }}
            </template>
            <template #open-indicator>
              <span></span>
            </template>
          </v-select>
        </b-form-group>

        <b-row>
          <b-col cols="6">
            <b-form-group
              label="Member #"
              :state="formErrors.member.length == 0 ? null : false"
              :invalid-feedback="formErrors.member.join(', ')"
            >
              <template v-slot:label>
                Member # <span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="form.member"
                trim
                maxLength="100"
                :state="formErrors.member.length == 0 ? null : false"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Group #"
              :state="formErrors.member.length == 0 ? null : false"
              :invalid-feedback="formErrors.group.join(', ')"
            >
              <template v-slot:label>
                Group # <span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="form.group"
                trim
                maxLength="100"
                :state="formErrors.group.length == 0 ? null : false"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" md="6">
            <b-form-group
              label="Relationship to subscriber"
              :state="formErrors.relationship.length == 0 ? null : false"
              :invalid-feedback="formErrors.relationship.join(', ')"
            >
              <template v-slot:label>
                <!-- Relationship to subscriber <span class="text-danger">*</span> -->
              </template>
              <v-select
                v-model="form.relationship"
                :options="relationships"
              ></v-select>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6" v-if="this.form.relationship.label === 'Other'">
            <b-form-group
              label="Relationship"
              :state="formErrors.relationshipOther.length == 0 ? null : false"
              :invalid-feedback="formErrors.relationshipOther.join(', ')"
            >
              <template v-slot:label>
                Relationship <span class="text-danger">*</span>
              </template>
              <b-form-input
                v-model="form.relationshipOther"
                trim
                maxLength="100"
                :state="formErrors.relationshipOther.length == 0 ? null : false"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" md="6">
        <b-form-group label="Insurance Card">
          <b-row>
            <b-col sm="12" md="6">
              <image-picker
                v-model="form.insuranceCardFrontBase64"
                :serverImageUrl="form.insuranceCardFrontUrl"
                labelText="Card Front"
              />
            </b-col>
            <b-col sm="12" md="6">
              <div class="pt-2 pt-md-0">
                <image-picker
                  v-model="form.insuranceCardBackBase64"
                  :serverImageUrl="form.insuranceCardBackUrl"
                  labelText="Card Back"
                />
              </div>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>

    <template
      v-if="this.form.relationship && this.form.relationship.label !== 'Self'"
    >
      <b-row>
        <b-col sm="12" md="4">
          <b-form-group
            label="First Name"
            :state="formErrors.firstName.length == 0 ? null : false"
            :invalid-feedback="formErrors.firstName.join(', ')"
          >
            <template v-slot:label>
              First Name <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.relationshipInfo.firstName"
              trim
              maxLength="100"
              :state="formErrors.firstName.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
          <b-form-group label="Middle Name">
            <b-form-input
              v-model="form.relationshipInfo.middleName"
              trim
              maxLength="100"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
          <b-form-group
            label="Last Name"
            :state="formErrors.lastName.length == 0 ? null : false"
            :invalid-feedback="formErrors.lastName.join(', ')"
          >
            <template v-slot:label>
              Last Name <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.relationshipInfo.lastName"
              trim
              maxLength="100"
              :state="formErrors.lastName.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="4">
          <b-form-group
            label="DOB"
            :state="formErrors.dob.length == 0 ? null : false"
            :invalid-feedback="formErrors.dob.join(', ')"
          >
            <template v-slot:label>
              DOB <span class="text-danger">*</span>
            </template>
            <date-picker
              :max="new Date()"
              :locale="$i18n.locale"
              v-model="form.relationshipInfo.dob"
              :errors="formErrors.dob"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
          <b-form-group
            label="SSN"
            :state="formErrors.ssn.length == 0 ? null : false"
            :invalid-feedback="formErrors.ssn.join(', ')"
          >
            <b-form-input
              v-model="form.relationshipInfo.ssn"
              v-facade="'###-##-####'"
              trim
              :state="formErrors.ssn.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
          <b-form-group
            label="Legal Sex"
            :state="formErrors.gender.length == 0 ? null : false"
            :invalid-feedback="formErrors.gender.join(', ')"
          >
            <template v-slot:label>
              Legal Sex
              <!-- <span v-if="isDoseSpotActive" class="text-danger">*</span> -->
            </template>
            <v-select
              v-model="form.relationshipInfo.gender"
              :options="genders"
            ></v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="4">
          <b-form-group
            label="Mobile Phone number"
            :state="formErrors.phone.length == 0 ? null : false"
            :invalid-feedback="formErrors.phone.join(', ')"
          >
            <template v-slot:label>
              Mobile Phone number
              <span class="text-danger">*</span>
            </template>
            <phone-input
              v-model="form.relationshipInfo.phone"
              trim
              :state="formErrors.phone.length == 0 ? null : false"
            ></phone-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
          <b-form-group
            label="Email"
            :state="formErrors.email.length == 0 ? null : false"
            :invalid-feedback="formErrors.email.join(', ')"
          >
            <template v-slot:label>
              Email
              <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.relationshipInfo.email"
              trim
              maxLength="150"
              :state="formErrors.email.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="6">
          <b-form-group
            label="Address Line 1"
            :state="formErrors.addressLine1.length == 0 ? null : false"
            :invalid-feedback="formErrors.addressLine1.join(', ')"
          >
            <template v-slot:label>
              Address Line 1
              <!-- <span v-if="isDoseSpotActive" class="text-danger">*</span> -->
            </template>
            <b-form-input
              v-model="form.relationshipInfo.addressLine1"
              trim
              maxLength="150"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6">
          <b-form-group label="Address Line 2">
            <b-form-input
              v-model="form.relationshipInfo.addressLine2"
              trim
              maxLength="150"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="4">
          <b-form-group
            label="City"
            :state="formErrors.city.length == 0 ? null : false"
            :invalid-feedback="formErrors.city.join(', ')"
          >
            <template v-slot:label>
              City
              <!-- <span v-if="isDoseSpotActive" class="text-danger">*</span> -->
            </template>
            <b-form-input
              v-model="form.relationshipInfo.city"
              trim
              maxLength="100"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
          <b-form-group
            label="State"
            :state="formErrors.state.length == 0 ? null : false"
            :invalid-feedback="formErrors.state.join(', ')"
          >
            <template v-slot:label>
              State
              <!-- <span v-if="isDoseSpotActive" class="text-danger">*</span> -->
            </template>
            <v-select
              v-model="form.relationshipInfo.state"
              :options="states"
            ></v-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="4">
          <b-form-group
            label="Zipcode"
            :state="formErrors.zipcode.length == 0 ? null : false"
            :invalid-feedback="formErrors.zipcode.join(', ')"
          >
            <template v-slot:label>
              Zipcode
              <!-- <span v-if="isDoseSpotActive" class="text-danger">*</span> -->
            </template>
            <b-form-input
              v-model="form.relationshipInfo.zipcode"
              v-facade="'#####'"
              trim
              :state="formErrors.zipcode.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </template>

    <div style="display: flex; justify-content: end;">
      <button
          :disabled="appointmentIsSubmit"
        @click="submitAppointment"
        style="color: #FFFFFF;"
        class="btn btn-success px-5"
      >
        {{ $t("step-request-appointment") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ImagePicker from "../../controls/ImagePicker.vue";
import PhoneInput from "../../controls/PhoneInput.vue";
import DatePicker from "../../controls/DatePicker.vue";
import {
  validateRequired,
  validatePhoneNumber,
  validateZipcode,
  validateSSN,
  validateEmail,
  validateDate
} from "../../../helpers/validation";
import { hasClass } from "../../../helpers/layout";
export default {
  name: "AppointmentInsuranceStep",
  components: { ImagePicker, PhoneInput, DatePicker },
  data() {
    return {
      form: {
        relationship: {
          label: "Self"
        },
        relationshipInfo: {}
      },
      formErrors: {
        insuranceCompany: [],
        member: [],
        group: [],
        relationship: [],
        firstName: [],
        middleName: [],
        lastName: [],
        dob: [],
        ssn: [],
        gender: [],
        phone: [],
        email: [],
        addressLine1: [],
        addressLine2: [],
        city: [],
        state: [],
        zipcode: [],
        relationshipOther: []
      },
      appointmentIsSubmit: false
    };
  },
  async mounted() {
    this.fetchInsuranceCompanies();
    await this.fetchRelationships();
    this.form.relationship = this.relationships.find(
      item => item.label === "Self"
    );
  },

  methods: {
    ...mapActions("client", ["fetchInsuranceCompanies", "fetchRelationships"]),
    submitAppointment() {
      if (!this.validateClientSubmit()) {
        return this.scrollToError();
      }
      this.appointmentIsSubmit = true;
      this.$emit("submit", null, this.form);
    },
    validateClientSubmit() {
      let withoutErrors = true;

      this.formErrors.insuranceCompany = [];
      if (!validateRequired(this.form.company)) {
        this.formErrors.insuranceCompany.push("Company name is required");
        withoutErrors = false;
      }

      this.formErrors.group = [];
      if (!validateRequired(this.form.group)) {
        this.formErrors.group.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.member = [];
      if (!validateRequired(this.form.member)) {
        this.formErrors.member.push("This field is required");
        withoutErrors = false;
      }

      if (this.form.relationship.label !== "Self") {
        if (this.form.relationship.label === "Other") {
          this.formErrors.relationshipOther = [];
          if (!validateRequired(this.form.relationshipOther)) {
            this.formErrors.relationshipOther.push("This field is required");
            withoutErrors = false;
          }
        }

        this.formErrors.firstName = [];
        if (!validateRequired(this.form.relationshipInfo.firstName)) {
          this.formErrors.firstName.push("This field is required");
          withoutErrors = false;
        }

        this.formErrors.lastName = [];
        if (!validateRequired(this.form.relationshipInfo.lastName)) {
          this.formErrors.lastName.push("This field is required");
          withoutErrors = false;
        }

        this.formErrors.dob = [];
        if (!validateRequired(this.form.relationshipInfo.dob)) {
          this.formErrors.dob.push("This field is required");
          withoutErrors = false;
        }

        if (
          this.form.relationshipInfo.dob &&
          !validateDate(this.form.relationshipInfo.dob)
        ) {
          this.formErrors.dob.push("This field must have a valid date format");
          withoutErrors = false;
        }

        this.formErrors.email = [];
        if (!validateEmail(this.form.relationshipInfo.email)) {
          this.formErrors.email.push(
            "This field must have a valid email format"
          );
          withoutErrors = false;
        }

        this.formErrors.phone = [];
        if (!validatePhoneNumber(this.form.relationshipInfo.phone)) {
          this.formErrors.phone.push("Invalid phone number");
          withoutErrors = false;
        }

        this.formErrors.ssn = [];
        if (
          this.form.relationshipInfo.ssn &&
          !validateSSN(this.form.relationshipInfo.ssn)
        ) {
          this.formErrors.ssn.push("This field must have a valid SSN format");
          withoutErrors = false;
        }

        this.formErrors.zipcode = [];
        if (
          this.form.relationshipInfo.zipcode &&
          !validateZipcode(this.form.relationshipInfo.zipcode)
        ) {
          this.formErrors.zipcode.push(
            "This field must have a valid Zipcode format"
          );
          withoutErrors = false;
        }

        return withoutErrors;
      }

      return withoutErrors;
    },
    scrollToError() {
      setTimeout(() => {
        let firstErrorElement = document.querySelector('[aria-invalid="true"]');
        let topPos = 0;
        while (!hasClass(firstErrorElement, "container")) {
          if (
            firstErrorElement &&
            firstErrorElement.offsetTop >= 0 &&
            firstErrorElement.offsetParent !== null
          ) {
            topPos += firstErrorElement.offsetTop;
            firstErrorElement = firstErrorElement.offsetParent;
          } else {
            break;
          }
        }
        document.querySelector(
          "div.scroll-content.p-sm-2.p-md-4.my-3"
        ).scrollTop = topPos - 400;
      }, 200);
    }
  },
  computed: {
    ...mapState({
      genders: state =>
        state.client.genders.map(gender => {
          return {
            label: gender.name,
            value: gender.id
          };
        }),
      states: state =>
        state.client.states.map(state => {
          return {
            label: state.name,
            value: state.id
          };
        }),
      insuranceCompanies: state =>
        state.client.insuranceCompanies.map(company => {
          return {
            label: company.name,
            value: company.id
          };
        }),
      relationships: state =>
        state.client.relationships.map(relation => {
          return {
            label: relation.name,
            value: relation.id
          };
        })
    }),
    insuranceData() {
      return this.form;
    }
  },
  watch: {
    "insuranceData.relationship": function(newValue) {
      newValue === null
        ? (this.insuranceData.relationship = this.relationships.find(
            item => item.label === "Self"
          ))
        : null;
    }
  }
};
</script>

<style scoped>
.scroll-content {
  overflow: auto !important;
}
</style>
